import React from "react";
import LegalLayout from "../../components/layout/LegalLayout";

const TermsPage: React.FC = () => (
  <LegalLayout>
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-blue-700 mb-6">TyreLink.app Terms and Conditions</h1>
        <p className="text-gray-700 mb-4"><strong>Effective Date:</strong> 30 September 2025</p>
        <p className="text-gray-700 mb-4"><strong>Company Details:</strong> TyreLink App (Pty) Ltd<br />
        <strong>Registration No:</strong> 2025/763420/07<br />
        <strong>Registered Office:</strong> 2 Suikerbekkie Street, Bromhof, Randburg, 2188<br />
        <strong>Contact:</strong> <a href="mailto:support@tyrelink.app" className="text-blue-600 hover:underline">support@tyrelink.app</a></p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">1. Acceptance of Terms</h2>
        <p className="text-gray-700 mb-4">
          By using TyreLink.app, you agree to these Terms and Conditions.<br />
          If you do not agree, you must stop using the app immediately.<br />
          TyreLink App (Pty) Ltd reserves the right to amend these Terms at any time, with updates posted on the app.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">2. Nature of Services</h2>
        <p className="text-gray-700 mb-4">
          TyreLink.app is a digital marketplace connecting users with tyre shops.<br />
          TyreLink does not sell tyres, provide fitting services, or process payments.<br />
          All transactions, warranties, and services are strictly between the customer and the tyre shop.<br />
          AI-driven recommendations are informational only and do not constitute advice. Users must verify tyre suitability before purchase or use.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">3. Eligibility and Registration</h2>
        <p className="text-gray-700 mb-4">
          You must be 18 years or older to register and use TyreLink.app.<br />
          You must provide accurate and complete details when creating an account.<br />
          TyreLink reserves the right to suspend or terminate accounts that provide false information or misuse the app.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">4. User Obligations</h2>
        <p className="text-gray-700 mb-4">
          You agree to use the app lawfully and not for fraudulent, unlawful, or harmful activities.<br />
          You may not copy, scrape, reverse-engineer, or misuse the platform.<br />
          You are responsible for the security of your account and login details.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">5. Liability and Indemnity</h2>
        <p className="text-gray-700 mb-4">
          TyreLink is an independent platform and is not liable for the quality, pricing, timing, or warranties of tyres or services provided by tyre shops.<br />
          All claims must be directed to the relevant tyre shop.<br />
          TyreLink’s liability is limited to the fullest extent permitted by law, excluding gross negligence, fraud, or wilful misconduct.<br />
          You indemnify TyreLink against all claims, damages, or losses arising from your use of the app.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">6. Data Protection and Privacy (POPIA Compliance)</h2>
        <p className="text-gray-700 mb-4">
          TyreLink collects the following personal information: Name, Contact details, Vehicle details (make, model, year, tyre size), Location.<br />
          Information is processed only to: Help you find local tyre shops, Match tyres to your vehicle, Send reminders or marketing communications (with consent).<br />
          Data is not sold or shared with tyre shops, advertisers, or third parties. Only tyre shop information is displayed to you.<br />
          Marketing communication will only be sent where you have opted in. You can opt out at any time.<br />
          By using TyreLink, you consent to the lawful processing of your personal information as required under POPIA.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">7. Marketing and Communication</h2>
        <p className="text-gray-700 mb-4">
          You may receive communications via email, SMS, or WhatsApp if you opt in.<br />
          You may unsubscribe at any time by following provided instructions.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">8. Intellectual Property</h2>
        <p className="text-gray-700 mb-4">
          All content, trademarks, logos, and software on TyreLink.app are owned by TyreLink App (Pty) Ltd.<br />
          You may not copy, distribute, or modify any part of the app without prior written consent.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">9. Competitions and Promotions</h2>
        <p className="text-gray-700 mb-4">
          Competitions, referral programmes, and promotions run on TyreLink are subject to separate rules published with each campaign.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">10. Termination of Use</h2>
        <p className="text-gray-700 mb-4">
          TyreLink may suspend or terminate accounts that violate these Terms, abuse the platform, or act unlawfully.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">11. Dispute Resolution</h2>
        <p className="text-gray-700 mb-4">
          All disputes must first be referred to arbitration in Johannesburg, South Africa, under the rules of the Arbitration Foundation of Southern Africa (AFSA).<br />
          If arbitration fails, disputes will be resolved in South African courts under South African law.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">12. Governing Law</h2>
        <p className="text-gray-700 mb-4">
          These Terms are governed by the laws of South Africa, including but not limited to the Consumer Protection Act (CPA), the Electronic Communications and Transactions Act (ECTA), and the Protection of Personal Information Act (POPIA).
        </p>

        <p className="text-gray-500 mt-8 text-sm">
          Last updated: September 2025
        </p>
      </div>
    </div>
  </LegalLayout>
);

export default TermsPage;